import { render } from "./dol-card.vue?vue&type=template&id=fc8cd2cc"
import script from "./dol-card.vue?vue&type=script&lang=js"
export * from "./dol-card.vue?vue&type=script&lang=js"

import "./dol-card.vue?vue&type=style&index=0&id=fc8cd2cc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__